import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import {
  buildCleaningParticipantCountColumn,
  buildEventScheduleColumn,
  buildEventViewIconColumn,
  CATERING_EVENT_LIST_TABLE_BASE,
} from './duna_catering_list.shared';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Public cleaning unique-events row (GET .../cleaning/unique-links/:uuid/events). */
export interface CleaningUniqueEventListItem {
  event_id: number;
  guid: string;
  event_type: string;
  start_date: string;
  end_date: string;
  event_name: string | null;
  location: string | null;
  room_name: string | null;
  participant_count: number;
}

export function duna_cleaning_unique_future(componentDataSourceService: ComponentDataSourceService) {
  const router = componentDataSourceService.injector.get(Router);
  const auth = componentDataSourceService.injector.get(AuthService);

  return {
    name: 'DUNA Cleaning Unique Future',
    description: 'Cleaning-flagged events for org token (not ended)',
    execute: (params?: LoadDataParams): Observable<any> => {
      const urlWithoutQuery = (router.url || '').split('?')[0];
      const linkUuid = urlWithoutQuery.split('/').find((segment) => UUID_REGEX.test(segment));
      if (!linkUuid) {
        return of({ items: [], totalCount: 0, pageSize: 10, pageIndex: 0 });
      }

      const mergedFilters = [...(params?.filters || [])];
      if (!mergedFilters.some((f) => f.column === 'period')) {
        mergedFilters.push({ column: 'period', value: 'future', operator: 'equals' } as any);
      }

      const requestParams: LoadDataParams = {
        ...(params || ({} as any)),
        dataSourceKey: 'duna_cleaning_unique_future',
        filters: mergedFilters
      };

      return componentDataSourceService['loadDataWithStandardFiltersGET'](
        'duna_cleaning_unique_future',
        `/events/cleaning/unique-links/${linkUuid}/events`,
        requestParams
      ).pipe(
        catchError((error) => {
          console.error('Error fetching cleaning unique future events:', error);
          return of({ items: [], totalCount: 0, pageSize: 10, pageIndex: 0 });
        }),
        map((result) => {
          const items = (result?.items || []) as CleaningUniqueEventListItem[];
          return {
            items,
            totalCount: result?.totalCount ?? items.length,
            pageSize: result?.pageSize ?? 10,
            pageIndex: result?.pageIndex ?? 0,
            filters: result?.filters
          };
        })
      );
    },
    settings: {
      columns: [
        buildEventScheduleColumn(),
        {
          key: 'event_name',
          header: 'Navn',
          type: 'text',
          sortable: true,
          wrap: true,
          fill: true,
        },
        { key: 'location', header: 'Lokation', type: 'text', sortable: true, wrap: true, fill: true },
        {
          key: 'room_name',
          header: 'Lokale',
          type: 'text',
          sortable: true,
          wrap: true,
          transform: (v: string | null) => (v == null || v === '' ? '–' : v),
        },
        buildCleaningParticipantCountColumn(),
        buildEventViewIconColumn(router, {
          showIf: () => auth.isAuthenticated,
        }),
      ],
      ...CATERING_EVENT_LIST_TABLE_BASE,
    }
  };
}
